<template>
  <v-card title="Szálláshelyek">
    <template v-slot:text>
      <v-text-field
        v-model="search"
        label="Keresés"
        prepend-inner-icon="mdi-magnify"
        variant="outlined"
        hide-details
        single-line
      ></v-text-field>
    </template>
    <v-data-table :headers="headers" :items="accommodations" :search="search">
      <template v-slot:[`item.id`]="{ item }">
        <v-chip
          color="blue"
          text="Részletek"
          @click="() => handleViewClick(item.id)"
        >
        </v-chip>
      </template>
    </v-data-table>
  </v-card>
</template>

<script lang="ts">
import { defineComponent, PropType, ref, toRefs } from "vue";
import router from "@/router";

export default defineComponent({
  name: "AdminAccommodations",
  props: {
    accommodations: {
      type: Array as PropType<any[]>,
      required: true,
    },
  },
  setup(props) {
    const search = ref("");
    const { accommodations: propAccommodations } = toRefs(props);

    const headers = ref([
      { title: "Szállás neve", value: "name", sortable: true },
      { title: "Város", value: "city", sortable: true },
      { title: "Szállás cím", value: "address", sortable: true },
      { title: "Számlázási cím", value: "billingAddress", sortable: true },
      { title: "Telefon", value: "phoneNumber", sortable: true },
      { title: "E-mail", value: "email", sortable: true },
      { title: "Részletek", value: "id", sortable: true },
    ]);

    return {
      headers,
      // eslint-disable-next-line vue/no-dupe-keys
      accommodations: propAccommodations,
      handleViewClick: (id: number) => {
        router.push("/admin/accommodation/details/" + id);
      },
      search: search,
    };
  },
});
</script>
